import {Consts} from "../pages/consts";
import DdiElement from "./DdiElement";
import DgiElement from "./DgiElement";
import {useTranslation} from "react-i18next";
import {buildDdiProduct, buildIntakeParams} from "./utils";

const DrugsAccordionBodyContent = ({drug, printView}) => {
  const { t } = useTranslation();

  const buildIntakes = (drug) => {
    const params = buildIntakeParams(drug);

    if (!params && drug?.timingType === Consts.DAY_TIMES) {
      return null;
    }

    return (
      <div className="w3-col">
        { drug?.timingType === Consts.DAY_TIMES ?
          <>
          { params?.dosages?.map((dosage, index) => {
            if (!dosage) {
              return null;
            }

            const timeOfDay = ["morning", "noon", "evening", "night"][index];

            return (
              <div key={ timeOfDay }>
                { t(timeOfDay) }: { dosage } { params?.unit && ` ${ t(params?.unit) }` }
              </div>
            );
          }) }
          </>
          :
          <>
            {drug?.intakes?.map((intake, index) => {
              return(
                <div key={ `intake ${index}` }>
                  { intake?.intakeTime }: { intake?.dosage } { intake?.dosageUnit && ` ${ t(intake?.dosageUnit) }` }
                </div>
              )
            })
            }
          </>
        }
      </div>
    );
  };

  const sortedDdis = drug?.ddis?.sort((a, b) => {
    if (a.ddiDrug?.activeSubstance < b.ddiDrug?.activeSubstance) {
      return -1;
    }

    if (a.ddiDrug?.activeSubstance > b.ddiDrug?.activeSubstance) {
      return 1;
    }

    return 0;
  });

  const handleSpecifyIntakes = (drug) => {
    console.log("handleSpecifyIntakes, drug", drug);
  };

  return (
    <>
      <div className="w3-container w3-border w3-round-large w3-margin-top w3-center">
        <div className="w3-row">
          <label className="bold-label">{ t("intake_plan") }</label>
        </div>
        <div className="w3-row">
          { drug?.intakeType === Consts.REGULARLY &&
            (drug?.intakes?.length > 0 ? (
              buildIntakes(drug)
            ) : (
              <button
                className="w3-btn w3-round-xlarge w3-theme-d5"
                onClick={ () => handleSpecifyIntakes(drug) }
              >
                { t("specify") }
              </button>
            )) }
          { drug?.intakeType === Consts.ON_DEMAND && (
            <label>{ t("on_demand") }</label>
          ) }
        </div>
      </div>
      { sortedDdis?.length > 0 && (
        <div className="w3-container w3-left-align w3-border w3-round-large w3-margin-top">
          <div className="w3-row">
            <label className="bold-label">
              { t("drug_drug_interactions_with") }
            </label>
          </div>
          { sortedDdis?.map((ddi, n) => {
            return (
              <DdiElement
                ddi={ ddi }
                productName={buildDdiProduct(ddi?.ddiDrug, t("not_specified"))}
                key={ `${ n }` }
              />
            );
          }) }
          <div className="w3-row">
            { printView ? (
              <label>
                { t("ddi_source") } (https://abdata.de/produkte/abdadatenbank2/)
              </label>
            ) : (
              <a
                href="https://abdata.de/produkte/abdadatenbank2/"
                target="_blank"
                rel="noopener noreferrer"
                className="w3-text-green"
              >
                { t("ddi_source") }
              </a>
            ) }
          </div>
        </div>
      ) }
      { drug?.dgis && (
        <div className="w3-container w3-left-align w3-border w3-round-large w3-margin-top">
          <div className="w3-row">
            <label className="bold-label">
              { t("drug_gene_interactions_with") }
            </label>
          </div>
          { drug?.dgis?.map((dgi, n) => {
            return <DgiElement dgi={ dgi } number={ n } key={ `${ n }` }/>;
          }) }
          <div className="w3-row">
            { printView ? (
              <label>
                { t("dgi_source") }{ " " }
                (https://www.knmp.nl/dossiers/farmacogenetica/pharmacogenetics)
              </label>
            ) : (
              <a
                href="https://www.knmp.nl/dossiers/farmacogenetica/pharmacogenetics"
                target="_blank"
                rel="noopener noreferrer"
                className="w3-text-green"
              >
                { t("dgi_source") }
              </a>
            ) }
          </div>
        </div>
      ) }
      { (drug?.ddis?.length > 0 || drug?.dgis?.length > 0) && (
        <div className="w3-row">
          <label className="notice-text">
            ⚠️ { t("always_discuss_with_hcp_notice") }
          </label>
        </div>
      ) }
    </>
  );
}

export default DrugsAccordionBodyContent;